export default __webpack_public_path__ + "static/media/element_73.53e3195b.webp";